import gql from 'graphql-tag';

export const ENERGY_PERF_CERT_FRAGMENT = gql`
    fragment ENERGY_PERF_CERT_FRAGMENT on ListingData {
        epc {
            image {
                caption
                filename
            }
            pdf {
                caption
                original
            }
        }
    }
`;
